/**
 * Feature Flags — controls activation of dormant systems.
 * Toggle FOUNDER_SYSTEM_ENABLED to true to activate founder features.
 */
export const FEATURE_FLAGS = {
  FOUNDER_SYSTEM_ENABLED: true, // admin preview ON
  FOUNDER_SYSTEM_ADMIN_ONLY: true, // restrict to @douevenlift.com when enabled
} as const;

export const FLAGS = {
  TRAINERS_ENABLED: false,
  NOTES_ENABLED: true,
  GYM_STAFF_NOTES_ENABLED: false,

  // V1-KILL: These features are explicitly disabled for V1 per Google Doc spec.
  // They must remain unreachable until ECR is proven.
  V1_BADGES_ENABLED: false,
  V1_FRIENDS_ENABLED: false,
  V1_MAP_ENABLED: false,
  V1_SUBSCRIPTIONS_ENABLED: true,
  V1_BODY_METRICS_ENABLED: false,
  V1_SOCIAL_FEED_ENABLED: false,       // Full social feed (posts, likes). Duel results only.
  V1_CHALLENGES_ENABLED: false,
  V1_GYM_CLAIMING_ENABLED: false,

  // Role dashboards — now built, gated by subscription tier
  COACH_DASHBOARD_ENABLED: true, // Coach Tier V1 — enabled 2026-04-05
  ORG_DASHBOARD_ENABLED: true,
  OWNER_DASHBOARD_ENABLED: true,

  // New V1 features
  V1_REST_TIMER_ENABLED: true,
  V1_PLATE_CALCULATOR_ENABLED: true,
  V1_QUICK_PR_ENABLED: true,
  V1_SEARCH_ENABLED: true,
  V1_OFFLINE_QUEUE_ENABLED: true,
  V1_PUSH_NOTIFICATIONS_ENABLED: true,
  V1_LIVE_DUELS_ENABLED: true,

  // V1 dev/debug routes
  V1_DEV_ROUTES_ENABLED: __DEV__,      // Only in dev mode
};

export function isFlagEnabled(flag: keyof typeof FLAGS): boolean {
  return FLAGS[flag] === true;
}
